/**
 * Created by ori on 20/09/16.
 */
import apiRequest from '../lib/api-request';

export default class User {
	constructor(state) {
	    this.state = state;
	}

	sendFeedback(feedbackData) {
	    return apiRequest(`user`,`send_feedback`,{"data":feedbackData});
	}
}


// WEBPACK FOOTER //
// ./src/js/actions/User.js